import clsx from 'clsx';
import React, { useState } from 'react';
import styled, { StylesProps } from '../../../lib/styles';

import coreBlockStyles from './CoreBlock_styles';

export interface CoreBlockProps {
  type: 'core_heading_block' 
    | 'core_paragraph_block'
    | 'core_cover_block'
    | 'core_columns_block'
    | 'core_list_block'
    | 'core_group_block'
  ;
  brand: string;
  classes: string;
  block: string;
}

const CoreBlock = ({
  type,
  classes,
  brand,
  block, 
  styles
}: CoreBlockProps & StylesProps<typeof coreBlockStyles>) => {
  console.log('CoreBlock', { type, classes, brand, block, styles });
  return (
    <div className={
      clsx(`${type} ${classes ?? ''} ${styles.container}`,
      {
        // [`container`]: type != 'core_cover_block',
      }
    )}
      dangerouslySetInnerHTML={{
        __html: block
      }}
    />
  );
};

export default styled(coreBlockStyles)(CoreBlock);
